import axios from '../config/axios'
import UserTag from '../models/UserTag'

export const findAll = () => axios.get<UserTag[]>('api/users/tags')

export default { findAll }
